var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_730_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.393 14.744C124.696 13.6871 126.323 13.1104 128 13.1104C129.678 13.1104 131.304 13.6871 132.607 14.744L241.139 102.933C242.277 103.856 243.111 105.1 243.533 106.503C243.956 107.906 243.947 109.403 243.508 110.801L202.734 239.896C202.265 241.375 201.338 242.667 200.087 243.585C198.835 244.502 197.324 244.998 195.772 245H60.2279C58.6742 244.997 57.1619 244.499 55.9102 243.579C54.6585 242.658 53.7325 241.363 53.2664 239.881L12.4919 110.816C12.0531 109.418 12.0443 107.92 12.4668 106.517C12.8892 105.114 13.7234 103.871 14.8611 102.947L123.379 14.7586L123.393 14.744Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_730_231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234,
    height: 234,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3f68922f4ee84dbcdf0fd19dcc958930.svg";
export { ForwardRef as ReactComponent };